const toggleAccordion = el => {
    const header = el.parent()
    const content = header.next();

    el.toggleClass('active');
    el.find('.fas').toggleClass('fa-plus fa-minus');
    content.toggleClass('active').slideToggle();
}

$(document).on('click', '.accordion-item__button', function() {
    // toggle other accordions
    if(!$(this).hasClass('active')){
        if($(this).hasClass('accordion-item__button--parent')){
            $('.accordion-item__content--parent .accordion-item__content--child.active').removeClass('active').slideUp();
            $('.accordion-item__content--parent .accordion-item__button--child.active').removeClass('active').find('.fas').removeClass('fa-minus').addClass('fa-plus');
            $('.accordion-item__content--parent.active').removeClass('active').slideUp();
            $('.accordion-item__button--parent.active').removeClass('active').find('.fas').removeClass('fa-minus').addClass('fa-plus');
        }else{
            $('.accordion-item__content--child.active').removeClass('active').slideUp();
            $('.accordion-item__button--child.active').removeClass('active').find('.fas').removeClass('fa-minus').addClass('fa-plus');
        }
    }
    toggleAccordion($(this));
});

// $(document).on('click', '.accordion-item__button--parent', function() {
//     if(!$(this).hasClass('active')){
//         $('.accordion-item__content--parent .accordion-item__content--child.active').removeClass('active').slideUp();
//         $('.accordion-item__content--parent .accordion-item__button--child.active').removeClass('active').find('.fas').removeClass('fa-minus').addClass('fa-plus');

//         $('.accordion-item__content--parent.active').removeClass('active').slideUp();
//         $('.accordion-item__button--parent.active').removeClass('active').find('.fas').removeClass('fa-minus').addClass('fa-plus');
//     }
//     toggleAccordion($(this));
// });



// $('.accordion-item__button.active').not(el).each( () => {
//     const header = el.parent()
//     const content = header.next();
//     el.toggleClass('active');
//     el.next().toggleClass('fa-plus fa-minus');
//     content.slideToggle();
// });
